package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun TeleportationCircleMetadata() {
    SpellMetadata(
        spellIndex = "teleportation-circle",
        castingTime = "1 minute",
        range = "10 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.MATERIAL),
        material = "Rare chalks and inks infused with precious gems with 50 gp, which the spell consumes.",
        duration = "1 round",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = "10-ft Sphere",
        concentration = false
    )
}
